<template>
    <a-drawer :title="title" width="350" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="员工信息" bordered :column="1" size="middle">
            <a-descriptions-item label="ID">
                {{ item.id }}
            </a-descriptions-item>
            <a-descriptions-item label="名称">
                {{ item.name }}
            </a-descriptions-item>
            <a-descriptions-item label="角色">{{ item.role | fmtUserRole }} [{{ item.role }}]</a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="绑定码" prop="code">
                <a-input v-model="field.code" placeholder="请填写绑定码" />
            </a-form-model-item>
            <a-form-model-item label="有效期（单位：小时）" prop="hour">
                <a-input-number v-model="field.hour" :min="1" :max="360" suffix="小时" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            field: {
                uid: '',
                code: '',
                hour: 360
            },
            rules: {
                code: [{ required: true, message: '请填写绑定码', trigger: 'blur' }],
                hour: [{ required: true, message: '请填写绑定码有效期', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.field.uid = this.item.id
    },
    methods: {
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/user/mgr/reset', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('重置成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
        }
    }
}
</script>
